import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../components/layout/Footer';
import AppNavbar from '../components/AppNavbar';

const PublicLayout: React.FC = () => {
  return (
    <div className="public-layout d-flex flex-column min-vh-100 bg-light">
      <AppNavbar />
      <main className="flex-grow-1 py-5">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
